import { render, staticRenderFns } from "./ShortCard.vue?vue&type=template&id=6ab4056f&"
import script from "./ShortCard.vue?vue&type=script&lang=js&"
export * from "./ShortCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports